import React, { useMemo } from "react";
import { style as iconStyle } from "../icon/Icon.style";
import { style as checkboxStyle } from "./Checkbox.style";
import "./Checkbox.web.css";
const TickIcon = ({ color, size }) => (React.createElement("svg", { "aria-hidden": "true", focusable: "false", height: size, style: { display: "block" }, viewBox: "0 0 2048 2048", width: size, xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M1336.05 703.411C1369.38 670.086 1423.41 670.086 1456.73 703.411C1490.06 736.735 1490.06 790.765 1456.73 824.09L944.732 1336.09C911.408 1369.41 857.378 1369.41 824.053 1336.09L591.326 1103.36C558.001 1070.04 558.001 1016.01 591.326 982.683C624.65 949.359 678.68 949.359 712.005 982.683L884.393 1155.07L1336.05 703.411Z", fill: color })));
const Checkbox = ({ checked }) => {
    const style = useMemo(() => checkboxStyle(), []);
    const icon = useMemo(() => iconStyle(), []);
    return (React.createElement("div", { "aria-checked": checked, className: "checkbox", "data-testid": "animated-checked", role: "checkbox", tabIndex: 0, style: {
            borderRadius: style.checkbox.borderRadius,
            borderWidth: style.checkbox.borderWidth,
            height: style.checkbox.height,
            width: style.checkbox.width,
            backgroundColor: checked ? style.colorIconHighlight : style.colorBgBase,
            borderColor: checked ? style.colorIconHighlight : style.colorBorderInteractive,
            transition: "background-color 200ms ease, border-color 200ms ease",
            outlineOffset: "2px",
        } },
        React.createElement("div", { style: {
                opacity: checked ? 1 : 0,
                transform: `scale(${checked ? 1 : 0})`,
                transition: "opacity 200ms ease, transform 200ms ease",
            } },
            React.createElement(TickIcon, { color: style.icon.color, size: icon.icon.height }))));
};
export { Checkbox };
